export default function getDate() {
    const dataAtual = new Date();
  
    // Obtendo os componentes da data
    const ano = dataAtual.getFullYear();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0"); // Mês começa do zero, então é necessário adicionar 1
    const dia = String(dataAtual.getDate()).padStart(2, "0");
  
    // Construindo a string da data e hora no formato desejado
    const dataFormatada = `${ano}-${mes}-${dia}`;
  
    return dataFormatada;
  }